var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.302 10.758q-1.852 0-3.139-1.286T1.877 6.333t1.286-3.139Q4.45 1.908 6.302 1.908T9.44 3.194q1.286 1.286 1.286 3.14 0 .74-.225 1.385a4 4 0 0 1-.61 1.136l3.702 3.705a.73.73 0 0 1 .21.532.7.7 0 0 1-.214.529.72.72 0 0 1-.53.211.72.72 0 0 1-.531-.211L8.83 9.923q-.495.385-1.144.61t-1.385.225m0-1.516q1.214 0 2.061-.848a2.8 2.8 0 0 0 .847-2.06q0-1.215-.847-2.062a2.8 2.8 0 0 0-2.061-.847q-1.215 0-2.061.847a2.8 2.8 0 0 0-.847 2.061q0 1.215.847 2.061a2.8 2.8 0 0 0 2.061.848"
  })));
};
export default SvgSearch;